<template>
  <div>
    <Table border :columns="columns" :data="list" :loading="listLoading" :row-class-name="rowClassName">
      <template slot="settled_amount_tax" slot-scope="{ row }">
        <span>{{ formatAmount(row.settled_amount_tax) }}</span>
      </template>
      <template slot="refund_amount_tax" slot-scope="{ row }">
        <span>{{ formatAmount(row.refund_amount_tax) }}</span>
      </template>
      <template slot="invoice_amount" slot-scope="{ row }">
        <span>{{ formatAmount(row.invoice_amount) }}</span>
      </template>
      <template slot="invoice_type_text" slot-scope="{ row }">
        <span>{{ row.invoice_type_text || '-' }}</span>
      </template>
      <template slot="action" slot-scope="{ row }">
        <span v-if="row.download_url" class="action-link" @click="$emit('download', row)">下载</span>
        <span v-else>-</span>
      </template>
    </Table>
    <div class="pagination-wrap">
      <Page :current="page" :total="total" show-elevator show-sizer show-total @on-change="handlePageChange"
        @on-page-size-change="handlePageSizeChange" />
    </div>
  </div>
</template>

<script>
import { Page, Table } from 'view-design'

export default {
  name: 'InvoicedTab',
  components: {
    Table,
    Page
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    listLoading: {
      type: Boolean,
      default: false
    },
    page: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      columns: [
        { title: '开票月份', key: 'invoice_month', minWidth: 120 },
        { title: '结算状态订单成交金额(含税)', slot: 'settled_amount_tax', minWidth: 220 },
        { title: '已结算退款订单退款额(含税)', slot: 'refund_amount_tax', minWidth: 220 },
        { title: '可开票金额', slot: 'invoice_amount', minWidth: 120 },
        { title: '开票类型', slot: 'invoice_type_text', minWidth: 100 },
        { title: '发票抬头', key: 'invoice_title', minWidth: 180 },
        { title: '开票主体', key: 'invoice_subject', minWidth: 180 },
        { title: '提交开票时间', key: 'submit_invoice_time', minWidth: 180 },
        { title: '开票时间', key: 'invoice_time', minWidth: 180 },
        { title: '操作', slot: 'action', width: 80, align: 'center' }
      ]
    }
  },
  methods: {
    rowClassName(row, index) {
      if (index % 2 === 0) {
        return 'bg-fa'
      }
      return 'bg-white'
    },
    formatAmount(value) {
      const numberValue = Number(value || 0)
      return numberValue.toFixed(2)
    },
    handlePageChange(page) {
      this.$emit('page-change', page)
    },
    handlePageSizeChange(pageSize) {
      this.$emit('page-size-change', pageSize)
    }
  }
}
</script>

<style scoped lang="less">
.action-link {
  color: #2d8cf0;
  cursor: pointer;
}

.pagination-wrap {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/invoice/modules/InvoicedTab.vue